import {
  Button,
  ButtonSize,
  ButtonColor,
} from './../../store/models/button.model';
import { INoAction } from './../../store/models/no-action.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import {
  ITableColumn,
  ITableDataSource,
  ITableFIlterGroup,
  EFilterType
} from 'app/store/models/table.model';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { SessionService } from 'app/store/services/session.service';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { takeUntil } from 'rxjs/operators';
import { UserType } from 'app/store/models/user.model';
import { setMessagesList } from 'app/store/actions/message.action';
import { openDialog } from 'app/store/actions/page.action';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-no-action',
  templateUrl: './no-action.component.html',
  styleUrls: ['./no-action.component.scss'],
})
export class NoActionComponent implements OnInit, OnDestroy {
  private destroy: Subject<boolean> = new Subject();

  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    filters: {},
  };
  tableFilterGroups: ITableFIlterGroup[] = [
            {
              filters: [
                {
                  type: EFilterType.SEARCH,
                  label: 'Search',
                  items: [
                    {
                      id: 'search',
                      label: 'Search...',
                    },
                  ],
                },
              ]
            }
    ];

  tableColumns: ITableColumn<INoAction>[];

  dataSource: ApiDataSource<INoAction>;

  deleteAllButtonProperties: Button = {
    onClick: () => {},
    size: ButtonSize.SMALL,
    text: 'Delete all',
    color: ButtonColor.RED,
  };

  tableReady: boolean;

  private popupShown: boolean;

  rowClass = (row: INoAction) => {
    return row.message_status + ' route_message';
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private leftMenu: LeftMenuService,
    private store: Store<IReducers>,
    private sessionService: SessionService
  ) {
    const apiEndpoint = environment.apiUrl + '/v1/messages/noaction';
    this.dataSource = new ApiDataSource<INoAction>(this.http, apiEndpoint);
    this.leftMenu.expand('inbox');
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy))
      .subscribe(sessionData => {
        if (sessionData.popup_tips) {
          if (this.popupShown) {
            return;
          }

          this.popupShown = true;
          this.store.dispatch(
            openDialog({
              dialogData: {
                content: InfoTipsComponent,
                title: 'Tips',
                canClose: true,
                dialogMinWidth: '700px',
                componentData: {
                  type: 'ok_got_it_popup',
                },
              },
            })
          );
        }
        const columns: ITableColumn<INoAction>[] = [
          {
            id: 'contact_firstname',
            title: 'Contact',
            renderer: row => {
              let contactName = row.contact_email;

              if (row.contact_firstname && row.contact_lastname) {
                contactName = `${row.contact_firstname} ${row.contact_lastname}`;
              }
              return contactName;
            },
            route: row => this.onColumnClick(row),
          },
          {
            id: 'contact_company',
            title: 'Company',
            route: row => this.onColumnClick(row),
          },
        ];

        if (
          [
            UserType.MANAGER,
            UserType.VSM,
            UserType.MASTER,
            UserType.PARTNER,
          ].indexOf(sessionData.user_type) !== -1
        ) {
          columns.push({
            id: 'account_firstname',
            title:
              sessionData.user_type === UserType.MASTER
                ? 'Account'
                : 'Representative',
            renderer: row => {
              if (row.universal_email) {
                return 'Universal email';
              } else {
                return `${row.account_firstname} ${row.account_lastname}`;
              }
            },
            route: row => this.onColumnClick(row),
          });
        }

        this.tableColumns = columns;
        this.tableReady = true;
      });
  }

  ngOnDestroy() {
    this.destroy.next(false);
  }

  onColumnClick(item: INoAction) {
    this.router.navigate([
      '/messages/view',
      item.message_id,
      {
        from: 'no_action',
      },
    ]);
  }

  onData = (items: INoAction[]) => {
    this.store.dispatch(
      setMessagesList({ list: items.map(item => item.message_id) })
    );
  };
}
